<template>
  <v-dialog persistent scrollable class="dialog" v-model="config.status.active">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat color="secondary white--text">
          <v-toolbar-title>請求書の読み込み</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="isPageMain" depressed
            color="white secondary--text"
            @click="openConfig"
            @done="updateConfig"
          >
            <v-icon small>fa-cog</v-icon>&nbsp;読み込み設定
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-window v-model="config.page">
          <v-window-item value="main">
            <Filer v-if="getRootId && config.status.active"
              :rid="getRootId"
              :filters="{ extensions: ['xls', 'xlsx'] }"
              :permits="{ add: true }"
              @select="select"
            />
          </v-window-item>
          <v-window-item value="confirm">
            <l-confirm :item="getItem" />
          </v-window-item>
        </v-window>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="isPageMain">
        <v-btn text
          color="secondary"
          @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed
          color="secondary"
          :loading="isLoading"
          :disabled="!isValid"
          @click="read">読み込む</v-btn>
      </v-card-actions>
      <v-card-actions v-else-if="isPageConfirm">
        <v-btn text
          color="secondary"
          @click="back">戻る</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed
          color="secondary"
          @click="insert">適用する</v-btn>
      </v-card-actions>
      <ConfigModal ref="config" @done="updateConfig" />
    </v-card>
  </v-dialog>
</template>

<script>
import Filer from '@/components/filers/client'
import ConfigModal from './modals/config'
import LConfirm from './layouts/confirm'
const DEF = {
  TYPE: 'insert',
  PAGE: 'main'
}
export default {
  name: 'BillModal',
  components: {
    Filer,
    ConfigModal,
    LConfirm
  },
  props: [
    'item'
  ],
  data () {
    return {
      config: {
        type: '',
        status: {
          active: false,
          loading: false
        },
        page: DEF.PAGE
      },
      meta: {
      },
      store: {
        config: {},
        item: null,
        items: []
      },
      form: {
        valid: false
      }
    }
  },
  methods: {
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    },
    validate: function (status) {
      if (status == null) {
        this.$refs.form.validate()
      } else {
        this.$set(this.form, 'valid', status)
      }
    },
    page: function (req) {
      if (req && req.dest) {
        this.$set(this.form, 'valid', true)
        this.$set(this.config, 'page', req.dest)
      }
    },
    read: function () {
      const item = this.store.items[0] || {}
      if (item.id) {
        this.submit({
          type: 'read',
          media: item,
          config: this.store.config
        })
      }
    },
    insert: function () {
      const { item } = this.$props || {}
      const media = this.store.items[0] || {}
      if (media && media.id) {
        this.submit({
          type: 'insert',
          id: item.id,
          media,
          form: this.store.item
        })
      }
    },
    preSubmit: function (req) {
      const { type, id, media, form, config } = req
      const cid = this.$route.params.id
      const urls = {
        insert: `${this.$url.api}cbook/insert/bill/${id}`,
        read: `${this.$url.api}cbook/read/bill/${media ? media.id : ''}`
      }
      const fds = {
        insert: { cid, media, form },
        read: { cid, cfg: config }
      }
      if (urls[type] && fds[type]) {
        const url = urls[type]
        const fd = fds[type]
        return { url, fd }
      } else {
        return false
      }
    },
    submit: function (req) {
      const { type } = req
      const dt = this.preSubmit(req)
      if (dt) {
        const { url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            },
            onUploadProgress: (e) => {
              this.$set(this.config.status, 'loading', Math.ceil(e.loaded / e.total * 100))
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({ type, data: res.data.data})
            } else {
              this.failSubmit(res.data)
            }
          })
        }).catch(err => {
          console.log(err)
          this.failSubmit(err)
        })
      }
    },
    postSubmit: function (req) {
      const { type, data } = req
      if (type === 'insert' || type === 'update') {
        this.$emit('done', { type: 'charges', item: data, forceLoad: true })
        this.close()
      } else if (type === 'read') {
        const { dates, charges } = data
        let dt = {}
        if (dates) {
          dt.dates = {
            due: dates.due || '',
            charged: dates.charged || ''
          }
        }
        if (charges) {
          dt.charges = {
            school: charges.school ? Math.round(charges.school) : '',
            stay: charges.stay ? Math.round(charges.stay) : '',
            flight: charges.flight ? Math.round(charges.flight) : '',
            insurance: charges.insurance ? Math.round(charges.insurance) : '',
            visa: charges.visa ? Math.round(charges.visa) : '',
            support: charges.support ? Math.round(charges.support) : '',
            domestic: charges.domestic ? Math.round(charges.domestic) : '',
            others: charges.others ? Math.round(charges.others) : '',
            total: charges.total ? Math.round(charges.total) : ''
          }
        }
        this.$set(this.store, 'item', dt)
        this.page({ dest: 'confirm' })
      }
      this.$set(this.config.status, 'loading', false)
    },
    failSubmit: function (req) {
      const { message } = req
      if (message) {
        const err = this.$error.xlsx.read[message] ? this.$error.xlsx.read[message] : ''
        if (err) {
          this.$store.dispatch('notifier/addAlert', {
            title: '読み込みの失敗',
            message: err
          })
        }
      }
      this.$set(this.config.status, 'loading', false)
    },
    open: function (req) {
      this.$set(this.config, 'page', DEF.PAGE)
      this.$set(this.config.status, 'active', true)
      this.$nextTick(() => {
        this.select()
        this.updateConfig(this.$refs.config.getForm())
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    back: function () {
      this.$set(this.config, 'page', 'main')
    },
    select: function (items) {
      let selects = items ? items.filter(it => {
        return (it.id && it.type && it.type !== 'folder')
      }) : this.store.items
      this.$set(this.store, 'items', selects)
      this.$set(this.form, 'valid', selects.length === 1)
    },
    openConfig: function () {
      this.$refs.config.open()
    },
    updateConfig: function (data) {
      this.$set(this.store, 'config', data)
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isValid () {
      return this.form.valid
    },
    isTypeInsert () {
      return this.config.type === 'insert'
    },
    isTypeUpdate () {
      return this.config.type === 'update'
    },
    isPageMain () {
      return this.config.page === 'main'
    },
    isPageConfirm () {
      return this.config.page === 'confirm'
    },
    isLoading () {
      return this.config.status.loading !== false
    },
    printLoading () {
      return Number.isFinite(this.config.status.loading) ? this.config.status.loading : 0
    },
    getStatus () {
      return this.config.status
    },
    getRootId () {
      return this.$store.getters['client/get']('lib').media
    },
    getItem () {
      return this.store.item
    }
  }
}
</script>
